import React from "react";
import classes from "./asttCard.module.css";
import { Box } from "@mui/material";

const Card = (props) => {
  return (
    <Box className={classes.card} sx={props.parentClientStyle}>
      {props.children}
    </Box>
  );
};

export default Card;
